import React from 'react';
import LocationTemplate from './LocationTemplate';

const RolesvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Rolesville"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27571"]}
      latitude={35.9234}
      longitude={-78.4578}
      population={9773}
      historicalFact="Named after William Roles, who donated land for the railroad in the 1800s."
      nearbyTowns={[
        "Wake Forest, NC",
        "Knightdale, NC",
        "Raleigh, NC",
        "Youngsville, NC",
        "Louisburg, NC",
        "Franklinton, NC",
        "Wendell, NC",
        "Zebulon, NC"
      ]}
    />
  );
};

export default RolesvillePage;